module.exports = __webpack_public_path__ + "img/pagina menu correios home.c2efdf06.png";